import * as messages from './validators-messages';
import * as consts from './validators-consts';

import { checkIfEmailAddressIsAlreadyTaken } from '../actions/public-actions';

export const passwordValidator = (password, repeatPassword) => {
  const errors = {};

  if (password && password.length < consts.PASSWORD_MIN_LENGTH) {
    errors["password"] = messages.PASSWORD_MIN_LENGTH_ERROR;
  }


  if (repeatPassword && password !== repeatPassword) {
    errors["repeatPassword"] = messages.PASSWORD_CONFIRM_ERROR;
  }
  
  return errors;
};

export const validatePassword = (password) => {
  let error;
  
  if (!password) {
    error = messages.REQUIRED_ERROR;
  } else if (password.length < consts.PASSWORD_MIN_LENGTH) {
    error = messages.PASSWORD_MIN_LENGTH_ERROR;
  }
  
  return error;
};

export const validateConfirmPassword = (password, confirmPassword) => {
  let error;
  
  if (!confirmPassword) {
    error = messages.REQUIRED_ERROR;
  } else if (confirmPassword && password !== confirmPassword) {
    error = messages.PASSWORD_CONFIRM_ERROR;
  }
  
  return error;
};


export function validateRequiredEmail(value) {
  let error;
  
  if (!value || value === '') {
    error = messages.REQUIRED_ERROR;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = messages.EMAIL_ERROR;
  }
  
  return error;
}

export const validateRequiredWithAsyncValidationEmail = (oldValue) => async (value) => {
  let error;

  if (!value || value === '') {
    error = messages.REQUIRED_ERROR;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = messages.EMAIL_ERROR;
  } else if (value !== oldValue) {
    const isTaken = await checkIfEmailAddressIsAlreadyTaken(value);
    if (isTaken) {
      error = messages.EMAIL_TAKEN_ERROR;
    }
  }

  return error;
};

export const emailValidator = (email) => {
  const errors = {};
  
  if (email.value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.value)) {
    errors[email.name] = messages.EMAIL_ERROR;
  }
  
  return errors;
};
